import React, { ReactNode } from "react";
import { TooltipProps as MuiTooltipProps } from "@mui/material";
import { StyledTooltip } from "./Tooltip.styled";
import { TooltipTitle } from "./TooltipTitle";

export interface TooltipProps extends Omit<MuiTooltipProps, "title"> {
  children: React.ReactElement<any, any>;
  /**
   * Set custom HTML content for the tooltip title.
   * If present, heading and text props are ignored.
   */
  title?: ReactNode;
  heading?: string;
  text?: string;
  type?: "dark" | "light";
}

export default function Tooltip({
  children,
  type = "dark",
  title,
  heading,
  text,
  ...props
}: TooltipProps) {
  const renderTitle = () => {
    if (title) {
      return title;
    }

    if (text) {
      return <TooltipTitle heading={heading} text={text} />;
    }

    return heading;
  };

  return (
    <StyledTooltip type={type} title={renderTitle()} {...props}>
      {children}
    </StyledTooltip>
  );
}
